module.exports = __webpack_public_path__ + "img/t2-1.62e521c3.jpg";